// extracted by mini-css-extract-plugin
export default {"wrapper":"Az-z","addressLine":"Bz-z","fullName":"Cz-z"};